import { action, makeObservable, runInAction } from "mobx";
import { MrbBaseViewStore } from "mrb/core";
import { MasterPasswordUpdateForm } from "administration/loadio/forms";
import { localizationService } from "common/localization";
import { applicationErrorCodes } from "common/constants";

class LoadioConfigurationViewStore extends MrbBaseViewStore {
    constructor(rootStore, { routeStore }) {
        super(rootStore);
        makeObservable(this);
        this.routeStore = routeStore;

        this.form = new MasterPasswordUpdateForm({
            onSuccess: () => {
                const data = this.form.values();
                return this.updateMasterPassword(data);
            },
            onInit: (form) => {
                form.$("currentPassword").focus();
            },
        });
    }

    @action updateMasterPassword = async (data) => {
        try {
            await this.routeStore.updateMasterPassword(data);
            runInAction(() => {
                this.form.clear();
                this.rootStore.notificationStore.success(
                    localizationService.t("ADMINISTRATION.LOADIO.CONFIGURATION.MASTER_PASSWORD_UPDATE_SUCCESS_MESSAGE")
                );
            });
        } catch (err) {
            let message = "ADMINISTRATION.LOADIO.CONFIGURATION.ERRORS.MASTER_PASSWORD_GENERIC_MESSAGE";
            if (err && err.data) {
                if (err.data.errorCode === applicationErrorCodes.loadio.invalidCurrentPassword) {
                    message = "ADMINISTRATION.LOADIO.CONFIGURATION.ERRORS.MASTER_PASSWORD_INVALID_CURRENT_PASSWORD";
                }
            }
            this.form.invalidate(message);
        }
    };

    destroy() {
        super.destroy();
        this.form.destroy();
    }
}

export default LoadioConfigurationViewStore;
